module.exports = __webpack_public_path__ + "static/assets/c29efc6aa6f21385bdbef4e451904a3f.svg";